// extracted by mini-css-extract-plugin
module.exports = {"RequisitionPreview":"_2c50Qcke","scrollDiv":"_1symERnj","RequisitionPreviewModal":"ynVKGUkh","scrollDivModal":"calZwGYr","contentContainer":"_3iLxSXeO","titleBlock":"_1_71AQZJ","title":"_2yj9xoG7","subTitle":"_22d0FB11"};
    if(module.hot) {
      // 1746735883836
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  